import React from "react";
import UserInfoCard from "src/components/CommunityFeed/UserInfoCard";
import { s3baseUrl } from "src/config/config";

export default function CoinsUsersList({
  feedActivity,
  totalPages,
  pageNumber,
  lastBookElementRef,
  loadMoreData,
  isLoadingMore,
}) {
  return (
    <div className="row feed-activity-box">
      {feedActivity.map((activity, index) => {
        return (
          <div className="col-12 mt-3" key={index}>
            <UserInfoCard
              profile_image={s3baseUrl + activity?.sender.profile_image}
              user_name={activity.sender?.name}
              avatar_char={activity.sender?.name}
              activity_type="coins"
              type={activity.sender?.user_type}
              fromCoins={true}
              activity={activity}
            />
          </div>
        );
      })}
      {totalPages > pageNumber ? (
        <div className="col-12 text-center">
          <span
            onClick={loadMoreData}
            className="load-more-text"
            ref={lastBookElementRef}
          >
            {isLoadingMore ? "Loading..." : "Load More"}
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
